import React from "react";
import Lottie from 'react-lottie-player';
import mouseRojo from '../Login/assets/Mouse.json';
import imagen4 from '../Login/assets/4LogoPortal.png';
import { useMediaQuery } from '@mui/material';

const NotFoundPage = () => {
    const isMobile = useMediaQuery('(max-width:900px)');

    const styles = {
        notfoundContainer: {
            position: 'relative',
            height: '100vh',
        },
        notfound: {
            position: 'absolute',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)',
            maxWidth: '920px',
            width: '100%',
            lineHeight: '1.4',
            textAlign: 'center',
            paddingLeft: '15px',
            paddingRight: '15px',
        },
        notfound404: {
            position: 'absolute',
            height: '100px',
            top: '0',
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: '-1',
        },
        notfound404H1: {
            fontFamily: 'Maven Pro, sans-serif',
            color: 'var(--color-surface-muted)',
            fontWeight: '900',
            fontSize: isMobile ? '162px' : '276px',
            margin: '0px',
            position: 'absolute',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)',
        },
        h2: {
            fontFamily: 'Maven Pro, sans-serif',
            fontSize: isMobile ? '26px' : '46px',
            color: 'var(--color-black)',
            fontWeight: '900',
            textTransform: 'uppercase',
            margin: '0px',
            marginTop: '90px',
        },
        link: {
            fontFamily: 'Maven Pro, sans-serif',
            fontSize: '14px',
            textDecoration: 'none',
            textTransform: 'uppercase',
            background: 'var(--color-accent-cyan)',
            display: 'inline-block',
            padding: '16px 38px',
            border: '2px solid transparent',
            borderRadius: '40px',
            color: 'var(--color-white)',
            fontWeight: '400',
            transition: '0.2s all',
            marginTop: '10px',
        },
        linkHover: {
            backgroundColor: 'var(--color-white)',
            borderColor: 'var(--color-accent-cyan)',
            color: 'var(--color-accent-cyan)',
        },
    };

    return (
        <div style={styles.notfoundContainer}>
            <div style={styles.notfound}>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                    <Lottie
                        loop
                        animationData={mouseRojo}
                        play
                        style={{ width: '5%', height: 'auto' }}
                    />
                    <img
                        src={imagen4}
                        alt="imagen3"
                        style={{ width: !isMobile ? '220px' : '150px', height: 'auto', marginLeft: !isMobile ? '10px' : '2px' }}
                    />
                </div>
                <div style={styles.notfound404}>
                    <h1 style={styles.notfound404H1}>404</h1>
                </div>
                <h2 style={styles.h2}>Lo sentimos, ¡Página no encontrada!</h2>
                <p>Por favor, verifique la dirección introducida e inténtelo de nuevo, visite la página principal o contacte con nuestro soporte técnico.</p>
                <a href="/" style={styles.link}>Volver a la página principal</a>
            </div>
        </div>
    );
};

export default NotFoundPage;

